import React, { useEffect, useState } from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { scheduledClosingsPublicApi } from '../../api/adminApi';
import {
  scheduledClosingId,
  scheduledClosingDescription,
  scheduledClosingDateInputValue,
  formatScheduledClosingDateShort,
} from '../Admin/ScheduledClosings/scheduledClosingHelpers';
import './PublicScheduledClosingPage.css';

function PublicScheduledClosingPage() {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!id) return;
    let cancelled = false;
    setLoading(true);
    setNotFound(false);
    scheduledClosingsPublicApi
      .getOne(id)
      .then((data) => {
        if (!cancelled) setItem(data);
      })
      .catch((err) => {
        if (cancelled) return;
        if (err.response?.status === 404) setNotFound(true);
        setItem(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [id]);

  if (!id) {
    return <Navigate to="/news-calendar" replace />;
  }

  if (loading) {
    return (
      <main className="public-sc-page">
        <div className="public-sc-inner">
          <p className="public-sc-loading">Loading…</p>
        </div>
      </main>
    );
  }

  if (notFound || !item || !scheduledClosingId(item)) {
    return (
      <main className="public-sc-page">
        <div className="public-sc-inner">
          <Link to="/news-calendar" className="public-sc-back">
            ← News &amp; School Calendar
          </Link>
          <h1 className="public-sc-title">Closing not found</h1>
          <p className="public-sc-muted">This date may have been updated or removed.</p>
          <Link to="/news-calendar" className="btn btn-primary public-sc-cta">
            Back to News &amp; Calendar
          </Link>
        </div>
      </main>
    );
  }

  const body = scheduledClosingDescription(item);
  const dateLabel = formatScheduledClosingDateShort(scheduledClosingDateInputValue(item));

  return (
    <main className="public-sc-page">
      <div className="public-sc-inner">
        <Link to="/news-calendar" className="public-sc-back">
          ← News &amp; School Calendar
        </Link>
        <article>
          <p className="public-sc-meta">
            <time dateTime={scheduledClosingDateInputValue(item) || undefined}>{dateLabel}</time>
            <span className="public-sc-meta-label"> School closed</span>
          </p>
          <h1 className="public-sc-title">{item.title || 'Scheduled closing'}</h1>
          {body ? (
            <div className="public-sc-body">{body}</div>
          ) : (
            <p className="public-sc-muted">No additional details.</p>
          )}
        </article>
      </div>
    </main>
  );
}

export default PublicScheduledClosingPage;
